import axios from 'utils/axios';

const BASE = 'event-notification-messages';

export type InboxItem = {
  _id: string;
  created_at?: string;
  senderType?: string;
  eventName?: string;
  subject?: string;
  bodyPreview?: string;
  isRead?: string;
  redirectUrl?: string;
};

export type InboxResponse = {
  items: InboxItem[];
  total: number;
  page: number;
  limit: number;
  unreadCount: number;
};

export async function fetchMyNotifications(page = 1, limit = 10, options?: { unreadOnly?: boolean }) {
  const params: Record<string, string | number | boolean> = { page, limit };
  if (options?.unreadOnly) {
    params.unreadOnly = true;
  }
  const res = await axios.get(BASE + '/inbox', { params });
  return res.data?.data as InboxResponse;
}

export async function markAllNotificationsRead() {
  await axios.put(BASE + '/mark-all-read', {});
}

export async function markNotificationRead(notificationMessageId: string) {
  await axios.put(BASE + '/mark-read', { notificationMessageId });
}

export type NotificationDetail = {
  _id: string;
  subject?: string;
  bodyHtml: string;
  isRead?: string;
  created_at?: string;
};

export async function fetchNotificationDetail(notificationMessageId: string) {
  const res = await axios.get(`${BASE}/inbox/message`, {
    params: { notificationMessageId }
  });
  return res.data?.data as NotificationDetail;
}
